import { useQuery } from "@tanstack/react-query";
import api from "../utils/api";

const fetchGetUserByEmail = ({ email }) => {
  return api.post(`/user/email`, { email });
};

export const useGetUserByEmailQuery = (email, checkEmailEnabled) => {
  return useQuery({
    queryKey: ["getUserByEmail", email],
    queryFn: () => fetchGetUserByEmail({ email }),
    enabled: checkEmailEnabled,
    select: (data) => {
      return data.data;
    },
  });
};
